<template>
  <div v-loading="isLoading">
    <el-table
      :data="locations"
      stripe
    >
      <el-table-column
        label="Suburb"
      >
        <template slot-scope="scope">
          <router-link :to="{ name: 'configuration-locations-location', params: { 'locationId': scope.row.id } }">
            {{ scope.row.suburb }}
          </router-link>
        </template>
      </el-table-column>
      <el-table-column
        label="State"
        prop="state"
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />
      <el-table-column
        label="Postcode"
        prop="postcode"
        :formatter="(row, col, cellValue) => cellValue || '-'"
      />
      <el-table-column
        label="Is PO Box"
        prop="pobox"
        :formatter="(row, col, cellValue) => (cellValue)? 'Yes': 'No' || '-'"
      />
      <el-table-column
        v-if="canUpdate || canDelete"
        label="Actions"
        align="right"
      >
        <template slot-scope="scope">
          <el-button
            v-if="canUpdate"
            size="mini"
            @click.native="editLocation(scope.$index, scope.row)"
          >
            Edit
          </el-button>
          <el-button
            v-if="canDelete"
            size="mini"
            type="danger"
            @click.native="deleteLocation(scope.$index, scope.row)"
          >
            Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { UPDATE, DELETE } from '@/plugins/user'
export default {
  props: {
    locations: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    canUpdate () {
      return this.$user.can(UPDATE, 'dictionary_location')
    },
    canDelete () {
      return this.$user.can(DELETE, 'dictionary_location')
    }
  },
  methods: {
    editLocation (index, row) {
      this.$emit('edit', row)
    },
    deleteLocation (index, row) {
      this.$confirm('Are you sure to delete this location?', 'Delete', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        row.delete()
          .then(() => this.$message({ message: 'Successfully deleted', type: 'success' }))
          .finally(() => {
            this.$emit('refresh')
          })
      }).catch(() => {})
    },
    resetFilters () {
      this.filters.account_location_name = null
      this.filters.account_location_by_deleted = null
    }
  }
}
</script>

<style>

</style>
